'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _smConst = require('../constants/sm-const');

var _smConst2 = _interopRequireDefault(_smConst);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isReviewing(room) {
  var status = room.stay_certification_status;
  return status === _smConst2.default.StayCertificationStatus.Created || status === _smConst2.default.StayCertificationStatus.Investigating;
}


function isDeclined(room) {
  var status = room.stay_certification_status;
  return status === _smConst2.default.StayCertificationStatus.Declined;
}

function isPublished(roomSetting) {
  return roomSetting && roomSetting.request_reviewed_at;
}

function isPublic(roomSetting) {
  return roomSetting && roomSetting.status === _smConst2.default.Visibility.Visible;
}

function isPrivate(rentalRoomSetting, stayRoomSetting) {
  return rentalRoomSetting.status === _smConst2.default.Visibility.Hidden && !stayRoomSetting.status || !rentalRoomSetting.status && stayRoomSetting.status === _smConst2.default.Visibility.Hidden || rentalRoomSetting.status === _smConst2.default.Visibility.Hidden && stayRoomSetting.status === _smConst2.default.Visibility.Hidden;
}

exports.default = {
  isReviewing: isReviewing,
  isDeclined: isDeclined,
  isPublished: isPublished,
  isPublic: isPublic,
  isPrivate: isPrivate
};


//////////////////
// WEBPACK FOOTER
// ./~/frontend_core/dist/model/Room.js
// module id = 2091
// module chunks = 0